export default __webpack_public_path__ + "static/media/p2023-15.f46d50ac.jpeg";